/* eslint-disable jsx-a11y/alt-text */
import React from "react";

const PopperContact = ({ children }) => {
  return (
    <div>
      <div className="fixed bottom-2 left-1 z-[99999999999]">
        <a
          className=" mb-4 w-[45px] shadow-2xl relative flex-center h-[45px] bg-[#007bff] block rounded-[50%] "
          href="https://zalo.me/0584564666"
        >
          <span className="w-[80%] h-[80%] bg-[#007bff] rounded-[50%] absolute animate-ping"></span>
          <img
            className="hover:opacity-80 transition "
            width="26px"
            src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/zalo.png?1700209535143"
          ></img>
        </a>
        <a
          className=" mb-4 w-[45px] shadow-2xl flex-center h-[45px] bg-[#0000f2] block rounded-[50%] relative"
          href="https://www.facebook.com/profile.php?id=61559704733274"
        >
          <span className="w-[80%] h-[80%] bg-[#0000f2] rounded-[50%] absolute animate-ping"></span>
          <img
            className="hover:opacity-80 transition"
            width="26px"
            src="//bizweb.dktcdn.net/100/485/241/themes/911577/assets/facebook.png?1700209535143"
          ></img>
        </a>

        <a
          className="relative mb-4 w-[45px] shadow-2xl flex-center h-[45px] bg-[#e60f1e] block rounded-[50%]"
          href="tel:0584564666"
        >
          <span className="w-[80%] h-[80%] bg-[#e60f1e] rounded-[50%] absolute animate-ping"></span>
          <i class="fa-solid fa-phone-volume text-white"></i>
        </a>
      </div>
      {children}
    </div>
  );
};

export default PopperContact;
